// extracted by mini-css-extract-plugin
export default {"expired_danger":"RenewalsModule_expired_danger__rwekz","expired_warning":"RenewalsModule_expired_warning__xsCNv"};